import React from 'react'
import { Modal } from 'react-bootstrap';

/**
 * DK : Modal z pytaniem tak/nie/anuluj (zwraca Yes, No, Cancel)
 * @param show Czy ma się wyświetlać 
 * @param onHide Funkcja wywołana gdy użytkownik odpowie na pytanie (zwraca Yes, No, Cancel) !!!
 */
const YesNoCancelMessageModal = ({ show, onHide, title, message, yesText = "Tak", noText = "Nie", cancelText = "Anuluj" }) => {
    return (
        <>
            <Modal size='lg' show={show} onHide={() => onHide('Cancel')} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ fontSize: '1.3rem' }}>{message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn-app-primary me-3' onClick={() => onHide('Yes')}>{yesText}</button>
                    <button className='btn-app-secondary' onClick={() => onHide('No')}>{noText}</button>
                    <button className='btn-app-secondary' onClick={() => onHide('Cancel')}>{cancelText}</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default YesNoCancelMessageModal